import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PersonApi } from '../+api';
import { CurriculumTreeInterface } from '../+models';

@Injectable({
  providedIn: 'root',
})
export class CurriculumTreeService {
  constructor(private personApi: PersonApi) {}

  getAllForUser(userId: number): Observable<CurriculumTreeInterface[]> {
    return this.personApi
      .getData(userId, 'curriculumTrees')
      .pipe(map((res: { curriculumTrees: CurriculumTreeInterface[] }) => res.curriculumTrees));
  }
}
